import React from "react";
import { useNavigate } from "react-router-dom";
import { Create } from "adminApi/RecruitmentApi/Recruitment";
import Spinner from "Common/Globle/Spinner";
import AddRecruitmentForm from "./components/AddRecruitmentForm";
import fields from "../json/Recruitment.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import { RecruitmentRules } from "validation/ValidationRules";
import { validateArrayForm } from "utils/validation";


const AddRecruitment = () => {
  const navigate = useNavigate();

  /**
   * Helper function to initialize form values from the fields array.
   */
  const buildInitialObject = (fields = []) =>
    fields.reduce((acc, field) => {
      acc[field.name] = "";
      return acc;
    }, {});

  /**
   * Initialize form values with default values.
   */
  const initialValues = {
    ...buildInitialObject(fields.basic),
    phone_country_dial_code: "+91",
    alternate_phone_country_dial_code: "+91",
    education: [buildInitialObject(fields.education)],
    experience: [{ ...buildInitialObject(fields.experience), supervisor_phone_country_dial_code: "+91" }]
  };

  /**
   * useFormChange hook to handle form changes.
   */
  const {
    values,
    errors,
    handleChange,
    handleArrayChange,
    handleFileChange,
    setValues,
    setErrors
  } = useFormChange(initialValues, RecruitmentRules);

  /**
   * useFormSubmit hook to handle form submission.
   */
  const { loading, handleSubmit } = useFormSubmit(
    async (formValues) => {
      const formData = new FormData();
      Object.entries(formValues).forEach(([k, v]) => {
        if (Array.isArray(v)) {
          formData.append(k, JSON.stringify(v));
        } else {
          formData.append(k, v ?? "");
        }
      });
      return await Create({ data: formData });
    },
    (vals) => {
      const err = validateArrayForm(vals, RecruitmentRules)
      setErrors(err);
      return err;
    },
    () => navigate(-1),
    "Candidate created successfully"
  );

  /**
   * Render the form.
   */
  return (
    <>
      {loading && <Spinner isSpinner />}
      <AddRecruitmentForm
        fields={fields}
        values={values}
        errors={errors}
        handleChange={handleChange}
        handleFileChange={handleFileChange}
        setValues={setValues}
        setErrors={setErrors}
        handleSubmit={(e) => handleSubmit(e, values)}
        loading={loading}
        title="Create Recruitment"
        handleArrayChange={handleArrayChange}
        validateArrayForm={validateArrayForm}
        rules={RecruitmentRules}
        buildInitialObject={buildInitialObject}
        imagePreview={values.profile_picturePreview || values.image_url}

      />
    </>
  );
};

export default AddRecruitment;
